module.exports = __webpack_public_path__ + "img/returnImg.c6c38c2c.png";